<template>
  <header>
    Header
  </header>
</template>

<script>
export default {
  name: "HeaderContainer"
}
</script>

<style>

</style>